import type { FreedrawData } from './types';

function isValidPoint(p: unknown): boolean {
  if (!Array.isArray(p)) return false;
  if (p.length < 2) return false;
  if (typeof p[0] !== 'number' || typeof p[1] !== 'number') return false;
  // pressure (p[2]) is optional but must be a number when present
  if (p.length >= 3 && typeof p[2] !== 'number') return false;
  return true;
}

export function isValidData(value: unknown): value is FreedrawData {
  if (typeof value !== 'object' || value === null) return false;
  const v = value as Record<string, unknown>;
  if (!Array.isArray(v.points)) return false;
  // Validate every point's structure — silently accepting [['oops', 0, 0.5]]
  // would crash the renderer downstream when path math hits NaN.
  for (const p of v.points) {
    if (!isValidPoint(p)) return false;
  }
  if (typeof v.initialSize !== 'object' || v.initialSize === null) return false;
  const sz = v.initialSize as { width: unknown; height: unknown };
  if (typeof sz.width !== 'number' || typeof sz.height !== 'number') return false;
  if (typeof v.strokeColor !== 'string') return false;
  if (typeof v.strokeWidth !== 'number' || v.strokeWidth <= 0) return false;
  if (v.strokeOpacity !== undefined && typeof v.strokeOpacity !== 'number') return false;
  return true;
}
